'use strict';

angular.module('onboarding.common.settings', []);
